<template>
  <div class="timer loading" v-if="!actionImmediate">
    You will be redirected in<span>.</span><span>.</span><span>.</span>
    {{ timeLeft }}
  </div>
</template>

<script>
export default {
  name: 'Timer',
  props: {
    initialTime: {
      type: Number,
      default: 10, // in seconds
    },
    immediate: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      timeLeft: this.initialTime,
      actionImmediate: this.immediate,
    }
  },

  mounted() {
    if (this.actionImmediate) this.$emit('time-over')
    const intervalId = window.setInterval(() => {
      this.timeLeft = this.timeLeft - 1
      if (!this.timeLeft) {
        window.clearInterval(intervalId)
        this.$emit('time-over')
      }
    }, 1000)
  },
}
</script>

<style scoped lang="scss">
.timer {
  font-size: 12px;
  line-height: 14.4px;
  margin: 0;
  padding: 16px 0 24px 0;

  @keyframes blink {
    0% {
      opacity: 0.2;
    }
    20% {
      opacity: 1;
    }
    100% {
      opacity: 0.2;
    }
  }

  &.loading span {
    padding: 0 1px;
    animation-name: blink;
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
  }

  &.loading span:nth-child(2) {
    animation-delay: 0.2s;
  }

  &.loading span:nth-child(3) {
    animation-delay: 0.4s;
  }
}
</style>
